import React from "react";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  alpha,
  useTheme,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useSelector } from "react-redux";

const NavItem = ({ item, isActive, isExpanded, onClick, onSubItemClick }) => {
  const theme = useTheme();
  const LoggedInUser = useSelector((state) => state.auth.user);

  const { label, icon, routes, roles } = item;
  const hasSubItems = routes && routes.length > 0;

  return (
    <>
      {(roles.includes("all") || roles.includes(LoggedInUser.role)) && (
        <>
          <ListItemButton
            onClick={onClick}
            selected={isActive && !hasSubItems} // Only select if it's a direct link
            sx={{
              // mb: 1,
              borderRadius: ".5rem",
              "&:hover": {
                backgroundColor: alpha(theme.palette.secondary.main, 0.2),
              },
              "&.Mui-selected": {
                color: "secondary.main",
                backgroundColor: alpha(theme.palette.secondary.main, 0.3),
                "&:hover": {
                  backgroundColor: alpha(theme.palette.secondary.main, 0.2),
                },
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 40, color: "inherit" }}>
              {icon}
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant="subtitle1" fontWeight={600} fontSize={15}>
                  {label}
                </Typography>
              }
            />
            {hasSubItems && (isExpanded ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>

          {hasSubItems && (
            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
              <List component="div" disablePadding sx={{ pl: 2 }}>
                {routes.map((subRoute) => (
                  <>
                    {(Array.isArray(subRoute.roles) &&
                      subRoute.roles.includes(LoggedInUser.role)) ||
                    subRoute.roles.includes("all") ? (
                      <ListItemButton
                        key={subRoute.path}
                        onClick={() => onSubItemClick(subRoute.path)}
                        selected={window.location.pathname === subRoute.path}
                        sx={{
                          // mb: 1,
                          pl: 4,
                          borderRadius: ".5rem",
                          "&:hover": {
                            backgroundColor: alpha(
                              theme.palette.secondary.main,
                              0.2
                            ),
                          },
                          "&.Mui-selected": {
                            color: "secondary.main",
                            backgroundColor: alpha(
                              theme.palette.secondary.main,
                              0.3
                            ),
                            "&:hover": {
                              backgroundColor: alpha(
                                theme.palette.secondary.main,
                                0.2
                              ),
                            },
                          },
                        }}
                      >
                        <ListItemText
                          primary={
                            <Typography
                              variant="body2"
                              fontSize={14}
                              fontWeight={"500"}
                            >
                              {subRoute.label}
                            </Typography>
                          }
                        />
                      </ListItemButton>
                    ) : null}
                  </>
                ))}
              </List>
            </Collapse>
          )}
        </>
      )}
    </>
  );
};

export default NavItem;
